import React from "react";
import EmailtemplateList from "./EmailTemplateList";
import EmailtemplateUpdate from "./EmailTemplateUpdate";
import { Route, Switch } from "react-router-dom";
class Index extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <Switch>      
        <Route
          path="/email-template/create/"
          render={props => (
            <EmailtemplateUpdate
              {...props}
              userPermissions={this.props.userPermissions} path="create"
            />
          )}
        />
        <Route
          path="/email-template/update/:id"
          render={props => (
            <EmailtemplateUpdate
              {...props}
              userPermissions={this.props.userPermissions}
            />
          )}
        />
        <Route
          path="/email-template"
          render={props => (
            <EmailtemplateList
              {...props}
              userPermissions={this.props.userPermissions}
            />
          )}
        />
      </Switch>
    );
  }
}

export default Index;
